import PropTypes from "prop-types"
import { useSelector } from 'react-redux'

import AddToCartButton from '@/components/PDP/PricingPanel/AddToCartButton'

import BulkStoreAddToCartButton from './BulkStoreAddToCartButton'

const ActionButton = ({ translations }) => {
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)

  return isBulkEnabled
    ? <BulkStoreAddToCartButton translations={translations} />
    : <AddToCartButton />
}

export default ActionButton

ActionButton.propTypes = {
  translations: PropTypes.shape({
    decrease_button: PropTypes.string,
    increase_button: PropTypes.string,
    quantity_label: PropTypes.string
  }).isRequired
}